import React from 'react'
import Section from './Section.jsx'
import Tooltip from '../tooltip/Tooltip.jsx'
import * as R from 'ramda'
import { pageProps } from '../types'
class Page extends React.Component {
  static propTypes = pageProps
  componentDidMount() {
    document.addEventListener('copy', this.modifyCopyText)
  }
  componentWillUnmount() {
    document.removeEventListener('copy', this.modifyCopyText)
  }

  modifyCopyText = e => {
    e.preventDefault()
    const isTranscript = e.target
      .closest('.flyout__content')
      .classList.contains('js-flyout__content--transcription')
    let newCitation, selection
    // const today = new Date()
    const highlight = window
      .getSelection()
      .getRangeAt(0)
      .cloneContents().childNodes
    if (highlight.length > 1) {
      const filterHighlight = R.filter(
        x => (x.classList ? !x.classList.contains('flyout-section__sup') : x),
        highlight
      )
      newCitation = R.map(x => x.textContent, filterHighlight)
      selection = newCitation.join('')
    } else {
      selection = window.getSelection().toString()
    }
    let citation = selection.trim()
    if (isTranscript) {
      // prettier-ignore
      citation = `"${selection.trim()}"\n\n"Vincenc Kramář, Notes on Picasso’s exhibition at the Thannhauser Gallery, 1913." Transcription. Leonard A. Lauder Research Center for Modern Art, The Metropolitan Museum of Art, New York, 2019.  https://www.metmuseum.org/art/libraries-and-research-centers/leonard-lauder-research-center/research/digital-archives/kramar-project.  A collaboration of the Ústav dějin umění Akademie věd České republiky, Prague, and The Leonard A. Lauder Research Center for Modern Art, The Metropolitan Museum of Art, New York.`
    } else {
      // prettier-ignore
      citation = `"${selection.trim()}"\n\n"Vincenc Kramář, Notes on Picasso’s exhibition at the Thannhauser Gallery, 1913." Leonard A. Lauder Research Center for Modern Art, The Metropolitan Museum of Art, New York, 2019. https://www.metmuseum.org/art/libraries-and-research-centers/leonard-lauder-research-center/research/digital-archives/kramar-project. Translated by Alex Zucker. A collaboration of the Ústav dějin umění Akademie věd České republiky, Prague, and The Leonard A. Lauder Research Center for Modern Art, The Metropolitan Museum of Art, New York.`
    }
    if (e.clipboardData) {
      e.clipboardData.setData('text/plain', citation)
    } else {
      window.clipboardData.setData('Text', citation)
    }
  }
  render() {
    const sectionContent = this.props.pageContent
    return (
      <div className="flyout-page">
        {!R.isEmpty(this.props.title) && (
          <h2 className="flyout-page__heading">
            <span>{this.props.title}</span>
          </h2>
        )}
        {Object.keys(sectionContent).map(key => (
          <Section
            key={key}
            currentView={this.props.currentView}
            sectionContent={sectionContent[key]}
            highlightedSection={this.props.highlightedSection}
            id={this.props.id}
            currentFootnotes={this.props.currentFootnotes}
            updateFootnote={this.props.updateFootnote}
            toggleDrawer={this.props.toggleDrawer}
            showAllFootnotes={this.props.showAllFootnotes}
          />
        ))}

        <span className="flyout-page__line" />
      </div>
    )
  }
}
export default Page
